export default __webpack_public_path__ + "static/media/lubaantunGrid22.26ab31ea.webp";